













































import { Component, Prop, Vue } from 'vue-property-decorator';

import ModalVue from '../Modal.vue';
import Hint from '../../../engine/Hint';


@Component({
    components: {
        ModalVue
    },
})
export default class MessageVue extends Vue {

    @Prop()
    private hints!: Hint[];
 
    close(){
        this.$emit('close');
    }

    mounted(){
        console.log(this.hints);
    }

    get idx_button() {

        for(let i=0; i<this.hints.length; i++){
            if(!this.hints[i].used){
                return i;
            }
        }

        return -1;

    }

    click(){
        this.hints[this.idx_button].useEvent();
    }

}

